module.exports = __webpack_public_path__ + "img/lc_fgyl.920d1f3c.svg";